var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d68828;}.cls-2{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1",
    d: "M35.86,32.48h0a4.89,4.89,0,0,1,4.89,4.89h0v9.9a1.51,1.51,0,0,1-1.51,1.51H32.49A1.52,1.52,0,0,1,31,47.27h0v-9.9A4.89,4.89,0,0,1,35.86,32.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-2",
    d: "M53.79,56.44H17.94a2.77,2.77,0,0,1-2.78-2.77v-29a1.15,1.15,0,0,1,2.3,0v29a.48.48,0,0,0,.48.48H53.79a.49.49,0,0,0,.48-.48v-29a1.15,1.15,0,1,1,2.29,0v29A2.77,2.77,0,0,1,53.79,56.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M61.94,30.37a1.14,1.14,0,0,1-.69-.23L36.15,11.32a.47.47,0,0,0-.57,0L10.48,30.14A1.15,1.15,0,0,1,9.1,28.3h0L34.2,9.48a2.77,2.77,0,0,1,3.33,0L62.63,28.3a1.14,1.14,0,0,1-.69,2.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.46b7831194eee446ae46d5bb2cd94ebe.svg";
export { ForwardRef as ReactComponent };